import {createSlice, createAction, createEntityAdapter, createAsyncThunk, createSelector} from "@reduxjs/toolkit";

export const detectLanguageGenerator = createAction("laguages/detectLanguageGenerator");

const languagesAdapter = createEntityAdapter({
  selectId: (language) => language.id,
});

const languagesSlice = createSlice({
  name: "languages",
  initialState: languagesAdapter.getInitialState({isLanguageDetected: false, languageDetectedId: 0,}),
  reducers: {
    resetDetectedLanguage:(state) =>{
      state.isLanguageDetected = false;
    },
    fetchLanguages: (state, action) => {
      languagesAdapter.addMany(state, action.payload);
    },
    detectLanguageSuccess: (state, action) => {
      state.languageDetectedId = action.payload.langId;
      state.isLanguageDetected = true;
    }
  },
});

//Selectors
export const languageSelectors = languagesAdapter.getSelectors((state) => state.languages);

export const languageStateSelecro = createSelector(
    (state) => state.languages,
    (languages) => languages,

)
export const { fetchLanguages,resetDetectedLanguage, detectLanguageSuccess} = languagesSlice.actions;
export default languagesSlice.reducer;
